export default __webpack_public_path__ + "static/media/November_04.c1e0d96f.png";